import { jsxs as f, jsx as o } from "react/jsx-runtime";
import { withManagedProps as C } from "@made-people/managed-props";
import { z as r } from "zod";
import { withZod as v } from "@made-people/react-prop-guard";
import { reviewCardBlueprint as y } from "./index-blueprint.es.js";
import { useTranslate as N } from "@made-people/grease-translations";
import "@made-people/blueprint";
const b = r.object({
  logo: r.custom().optional(),
  id: r.string()
}).array().optional(), R = r.object({
  variants: r.custom().optional(),
  review: r.string().optional(),
  author: r.string().optional(),
  ratingValue: r.union([r.string(), r.number()]).transform((t) => typeof t == "string" ? parseFloat(t) : t).optional(),
  ratingScale: r.union([r.string(), r.number()]).transform((t) => typeof t == "string" ? parseFloat(t) : t).optional(),
  collectedByOptions: b,
  collectedBy: r.string().optional()
}), k = C(
  "ReviewCard",
  v(
    {
      schema: R,
      defaultProps: {
        ratingScale: 5
      }
    },
    ({
      variants: t,
      review: n,
      author: s,
      ratingValue: i,
      ratingScale: l,
      collectedBy: u,
      collectedByOptions: a
    }) => {
      var p;
      const e = y.styles(t), h = N(), c = !l || !i, m = (p = a == null ? void 0 : a.find(
        (d) => d.id === u
      )) == null ? void 0 : p.logo, w = () => c ? null : Array.from({ length: l }).map((d, g) => /* @__PURE__ */ o(
        "span",
        {
          "data-is-active": g < i ? "true" : "false",
          className: e.star,
          children: "★"
        },
        g
      ));
      return /* @__PURE__ */ f("div", { className: e.base, children: [
        !c && /* @__PURE__ */ o("div", { className: e.starContainer, children: w() }),
        n && /* @__PURE__ */ o("p", { className: e.review, children: n }),
        s && /* @__PURE__ */ o("p", { className: e.author, children: s }),
        m && /* @__PURE__ */ f("div", { className: e.collectedBy, children: [
          /* @__PURE__ */ o("span", { children: h("Review_Card_CollectedBy") }),
          m
        ] })
      ] });
    }
  )
);
export {
  k as ReviewCard,
  R as reviewCardSchema
};
//# sourceMappingURL=index.es.js.map
